﻿import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { catGenero } from "../Categorias y Estados/catGenero";
import { catTiposDocumento } from "../Categorias y Estados/catTiposDocumento";

const columns = () =>
(
    {
        c_persona_id: new EntityColumn<string>({ name: 'c_persona_id', type: 'char', length: 20, flags: c.PKAutonum, prompt: 'Persona Id' }),
        vc_nombre: new EntityColumn<string>({ name: 'vc_nombre', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Nombre' }),
        vc_apellido: new EntityColumn<string>({ name: 'vc_apellido', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Apellido' }),
        dt_nacimiento: new EntityColumn<Date>({ name: 'dt_nacimiento', type: 'date', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fecha de Nacimiento' }),
        c_fotofileprocess_id: new EntityColumn<string>({ name: 'c_fotofileprocess_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Fotofileprocess Id' }),
        c_tipodocumento_id: new EntityColumn<string>({ name: 'c_tipodocumento_id', type: 'char', length: 20, flags: c.Edit, prompt: 'Tipo de Documento' }),
        vc_numerodocumento: new EntityColumn<string>({ name: 'vc_numerodocumento', type: 'varchar', length: 255, flags: c.Edit, prompt: 'Número de Documento' }),
        c_genero_id: new EntityColumn<string>({ name: 'c_genero_id', type: 'char', length: 20, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Género' }),
        c_documentofileprocess_id: new EntityColumn<string>({ name: 'c_documentofileprocess_id', type: 'char', length: 20, flags: c.FK | EntityColumnFlags.nullable, prompt: 'Documentofileprocess Id' }),
        vc_fotoguid: new EntityColumn<string>({ name: 'vc_fotoguid', type: 'varchar', length: 255, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Fotoguid' }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        pers_brwStandard: { name: 'pers_brwStandard', keyMappings: { c_persona_id: 0 } },
        pers_brwCard: { name: 'pers_brwCard', keyMappings: { c_persona_id: 0 } },
    }
)


const lookups = () =>
(
    {
        'TiposDocumento': {
            name: 'TiposDocumento',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catTiposDocumento(client, parentKeys)
        },

        'Genero': {
            name: 'Genero',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new catGenero(client, parentKeys)
        }

    }   
)

export class PersonasDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();

    constructor() {
        super('Personas');
    }
}